<template>
    <div id="cursor">
      <div class="cursor__circle"></div>
    </div>
  
    <header class="header header-default header-sticky header-absolute">
      <div class="header-inner">
        <!-- LOGO -->
        <div class="site-logo">
          <a class="navbar-brand brand-logo" href="index.html">
            <span class="brand-icon">
              <span class="brand-icon-box left"></span>
              <span class="brand-icon-box right"></span>
            </span>
  
            <span class="brand-text">
              <span class="brand-next"> Next</span>
              <span class="brand-line">Line</span>
              <span class="brand-dot">.uz</span>
            </span>
          </a>
        </div>
  
        <!-- DESKTOP MENU (hozircha o‘chirib qo‘yilgan) -->
        <div class="site-menu d-none d-xl-block">
          <!--
          <ul class="main-menu">
            ...
          </ul>
          -->
        </div>
  
        <!-- DESKTOP ACTION (o‘ng tomondagi 3 chiziq) -->
        <div class="site-action d-none d-xl-block">
          <div class="action-hamburger">
            <a
              class="hamburger"
              href="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
            >
              <span class="hamburger-container">
                <span class="hamburger-inner"></span>
                <span class="hamburger-hidden"></span>
              </span>
            </a>
          </div>
        </div>
  
        <!-- MOBIL MENYU TUGMASI -->
        <div class="mobile-action d-block d-xl-none">
          <div class="mobile-hamburger">
            <a
              class="hamburger"
              href="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#menuOffcanvas"
              aria-controls="menuOffcanvas"
            >
              <span class="hamburger-container">
                <span class="hamburger-inner"></span>
                <span class="hamburger-hidden"></span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </header>
  </template>
  
  <script setup>
  import { onMounted } from 'vue';
  
  onMounted(() => {
    const circle = document.querySelector('.cursor__circle');
    let mouseX = 0;
    let mouseY = 0;
    let currentX = 0;
    let currentY = 0;
    const speed = 0.1; // qancha kichik bo‘lsa, harakat shuncha yumshoq bo‘ladi
  
    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });
  
    function animate() {
      currentX += (mouseX - currentX) * speed;
      currentY += (mouseY - currentY) * speed;
      if (circle) {
        circle.style.transform = `translate(${currentX}px, ${currentY}px)`;
      }
      requestAnimationFrame(animate);
    }
  
    animate();
  });
  </script>
  
  <style scoped>
  /* NextLine.uz LOGO DIZAYNI */
  .brand-logo {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
  }
  
  .brand-icon {
    display: inline-flex;
    gap: 6px;
    align-items: center;
  }
  
  .brand-icon-box {
    width: 26px;
    height: 26px;
    border-radius: 8px;
    border: 2px solid #3b82f6;
    box-shadow: 0 0 10px rgba(59, 130, 246, 0.6);
  }
  
  .brand-icon-box.left {
    border-right: none;
    transform: skewX(-15deg);
  }
  
  .brand-icon-box.right {
    border-left: none;
    transform: skewX(15deg);
  }
  
  .brand-text {
    font-family: 'Poppins', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',
      sans-serif;
    display: inline-flex;
    align-items: baseline;
    font-weight: 700;
    letter-spacing: 0.04em;
    font-size: 26px;
  }
  
  .brand-next {
    color: #ffffff;
  }
  
  .brand-line {
    margin-left: 4px;
    background: linear-gradient(90deg, #22d3ee, #3b82f6);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
  
  .brand-dot {
    margin-left: 2px;
    font-weight: 500;
    font-size: 18px;
    color: #9ca3af;
  }
  
  /* Kichik ekranlarda biroz kichraytirish */
  @media (max-width: 991.98px) {
    .brand-text {
      font-size: 20px;
    }
  
    .brand-dot {
      font-size: 14px;
    }
  
    .brand-icon-box {
      width: 22px;
      height: 22px;
    }
  }
  </style>
  